import { render, staticRenderFns } from "./MessageHome.vue?vue&type=template&id=76ba5eaa&"
import script from "./MessageHome.vue?vue&type=script&lang=js&"
export * from "./MessageHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports